import type { GetApiV1ThreeLetterCodePartnerAdminsGroups200 } from '@fukuri-admins/apis/client/gen/model';
import { CreateTopBannerFormPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof CreateTopBannerFormPresentation>;

type IConvertToPresentationProps = (args: {
  /** グループ一覧データ */
  groupsData: GetApiV1ThreeLetterCodePartnerAdminsGroups200;
}) => {
  groupList: PresentationProps['groupList'];
};

/**
 * hooksの状態をプレゼンテーション用のpropsに変換する
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ groupsData }) => {
  const groupList = groupsData.groups.map(group => ({
    id: String(group.id),
    name: group.name,
    code: group.code,
  }));

  return {
    groupList,
  };
};
